export function parseIntOr(toParse, defaultValue) {
  return typeof toParse === 'number' ?
    toParse :
    (
      typeof toParse === 'string' && !isNaN(toParse) ?
        parseInt(toParse) :
        defaultValue
    );
}

export function parseJsonIfNeeded(toParse) {
  return typeof toParse === 'string' ?
    JSON.parse(toParse) :
    toParse;
}

export function parseJsonIfNeededFromUrlParam(query, param) {
  return (query && typeof query === 'object' && param in query && query[param]) ?
    parseJsonIfNeeded(query[param]) :
    null;
}



// WEBPACK FOOTER //
// ./src/utils/UrlParamParsers.js